@if (company) {
<!-- Onboarding Guide -->
<app-company-onboarding-guide
  [company]="company"
  [hasNewsPosts]="hasNewsPosts"
  [hasContacts]="hasContacts"
  [hasSponsors]="hasSponsors"
  [hasDocuments]="hasDocuments"
  [hasEvents]="hasEvents"
  (navigateToTab)="onNavigateToTab($event)"
/>

<div class="main pt-3">
  <div class="container " style="max-width: 1400px">
    <div class="row spacing-20">
      <div class="card p-0">
        <div class="card-header rounded-top bgi-size-cover position-relative" [style.background-image]="'url(' + company.header_image_url + ')'" style="background-position: 100% 50%; height: 300px">
          <app-button
            [variant]="'ghost'"
            [iconClass]="'fa fa-camera fs-2'"
            [size]="'lg'"
            class="position-absolute"
            style="top: 10px; right: 30px; z-index: 10; width: 35px; height: 35px; padding: 0;"
            (clicked)="openUpdateImageModal('header')"
          />
        </div>
        <div class="card-body mt-n19">
          <div class="m-0">
            <div class="d-flex flex-stack align-items-end pb-4 mt-n19">
              <div class="symbol symbol-125px symbol-lg-150px symbol-fixed position-relative mt-n3">
                @if (company.company_logo_url){
                  <img [src]="company.company_logo_url" alt="image" class="border border-white border-4" style="border-radius: 20px" />
                } @else {
                  <div
                    class="d-flex justify-content-center align-items-center border border-white border-4 bg-light"
                    style="border-radius: 20px; width: 100%; height: 100%; color: #555c61;"
                  >
                    <i class="fa-regular fa-building fs-7x m-5"></i>
                  </div>
                }
                <app-button
                  [variant]="'ghost'"
                  [iconClass]="'fa fa-camera'"
                  [size]="'sm'"
                  class="position-absolute"
                  style="bottom: 3px; right: 25px; width: 35px; height: 35px; border-radius: 50%; padding: 0;"
                  (clicked)="openUpdateImageModal('logo')"
                />
              </div>
            </div>
            <div class="d-flex flex-stack flex-wrap align-items-end">
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-2">
                  <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">{{ company.company_name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modern Tab Navigation -->
    <div class="profile-tabs-wrapper">
      <div class="profile-tabs">
        <button class="profile-tab" [class.active]="selectedTab === 'information'" (click)="selectTab('information')">
          <i class="fa fa-info-circle me-2"></i>
          <span>{{ 'companyProfile.tabs.information' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'events'" (click)="selectTab('events')">
          <i class="fa fa-calendar me-2"></i>
          <span>{{ 'companyProfile.tabs.events' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'feed'" (click)="selectTab('feed')">
          <i class="fa fa-newspaper me-2"></i>
          <span>{{ 'companyProfile.tabs.feed' | translate }}</span>
        </button>
        @if (company.company_type !== 'stable' && company.company_type !== 'riding_school' && company.company_type !== 'stores_services') {
          <button class="profile-tab" [class.active]="selectedTab === 'memberships'" (click)="selectTab('memberships')">
            <i class="fa fa-id-card me-2"></i>
            <span>{{ 'companyProfile.tabs.membershipPlans' | translate }}</span>
          </button>
        }
        @if (company.company_type !== 'riding_club' && company.company_type !== 'stores_services') {
          <button class="profile-tab" [class.active]="selectedTab === 'services'" (click)="selectTab('services')">
            <i class="fa fa-boxes-stacked me-2"></i>
            <span>{{ 'companyProfile.tabs.services' | translate }}</span>
          </button>
        }
        <button class="profile-tab" [class.active]="selectedTab === 'documents'" (click)="selectTab('documents')">
          <i class="fa fa-file-alt me-2"></i>
          <span>{{ 'companyProfile.tabs.documents' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'sponsors'" (click)="selectTab('sponsors')">
          <i class="fa fa-handshake me-2"></i>
          <span>{{ 'companyProfile.tabs.sponsors' | translate }}</span>
        </button>
        @if (company.company_type === 'stores_services') {
          <button class="profile-tab" [class.active]="selectedTab === 'deals'" (click)="selectTab('deals')">
            <i class="fa fa-tag me-2"></i>
            <span>{{ 'companyProfile.tabs.deals' | translate }}</span>
          </button>
        }
        <button class="profile-tab" [class.active]="selectedTab === 'admin'" (click)="selectTab('admin')">
          <i class="fa fa-users-cog me-2"></i>
          <span>{{ 'companyProfile.tabs.userAdmin' | translate }}</span>
        </button>
        <button class="profile-tab" [class.active]="selectedTab === 'billing'" (click)="selectTab('billing')">
          <i class="fa fa-credit-card me-2"></i>
          <span>{{ 'companyProfile.tabs.billing' | translate }}</span>
        </button>
      </div>
    </div>
    @if (selectedTab == 'information') {
      <app-company-profile-overview
        [company]="company"
        (dataChanged)="onDataChanged()"
      />
    }
    @else if (selectedTab == 'events') {
      <app-company-profile-events
        [company]="company"
      />
    }
    @else if (selectedTab == 'feed') {
      <app-company-profile-feed
        [company]="company"
        (dataChanged)="loadOnboardingStatus()"
      />
    }
    @else if (selectedTab == 'memberships') {
      <app-company-profile-membership-plans
        [company]="company"
      />
    }
    @else if (selectedTab == 'services') {
      <app-company-profile-services
        [company]="company"
      />
    }
    @else if (selectedTab == 'documents') {
      <app-company-profile-documents
        [company]="company"
        (dataChanged)="loadOnboardingStatus()"
      />
    }
    @else if (selectedTab == 'sponsors') {
      <app-company-profile-sponsors
        [company]="company"
        (dataChanged)="loadOnboardingStatus()"
      />
    }
    @else if (selectedTab == 'deals') {
      <app-company-profile-deals
        [company]="company"
      />
    }
    @else if (selectedTab == 'admin') {
      <app-company-profile-users
        [company]="company"
        [userRole]="selectedCompany.role_id"
      />
    }
    @else if (selectedTab == 'billing') {
      <app-company-profile-billing
        [company]="company"
        [userRole]="selectedCompany.role_id"
        (companyUpdated)="onDataChanged()"
      />
    }
  </div>
</div>
} @else {
  <div class="main pt-3">
    <div class="container" style="max-width: 1400px">
      <div class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
}
